import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import AdminLayout from '../../components/AdminLayout';

function Settings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/settings').then(res => setSettings(res.data));
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put('/settings', settings);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      alert('Failed to save settings');
    }
    setLoading(false);
  };

  const updateSetting = (key, value) => {
    setSettings({ ...settings, [key]: value });
  };

  return (
    <AdminLayout>
      <h2>Site Settings</h2>
      {saved && <div className="alert alert-success">Settings saved successfully!</div>}

      <div className="admin-form">
        <div className="form-group">
          <label>Site Name</label>
          <input type="text" value={settings.site_name || ''} onChange={e => updateSetting('site_name', e.target.value)} className="form-input" />
        </div>
        <div className="form-group">
          <label>Site Description</label>
          <textarea value={settings.site_description || ''} onChange={e => updateSetting('site_description', e.target.value)} className="form-input" rows="3" />
        </div>
        <div className="form-group">
          <label>Items Per Page</label>
          <input type="number" value={settings.items_per_page || 24} onChange={e => updateSetting('items_per_page', e.target.value)} className="form-input" style={{ width: 120 }} />
        </div>
        <div className="form-group">
          <label className="checkbox-label">
            <input type="checkbox" checked={settings.require_approval === '1'} onChange={e => updateSetting('require_approval', e.target.checked ? '1' : '0')} />
            Require admin approval for new resources (uploaded by non-admin users)
          </label>
        </div>
        <button onClick={handleSave} className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save Settings'}
        </button>
      </div>
    </AdminLayout>
  );
}

export default Settings;
